import React, { useEffect, useState } from 'react';
import { Box, HStack, Text, VStack, useMediaQuery, Spinner } from 'native-base';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import WebHeader from '../layout/header/webHeader';
import MobileHeader from '../layout/header/mobileHeader';
import { COLORS } from '../utils/colors';
import { MOBILE_VIEW_WIDTH } from '../utils/screens';
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from '../utils/fonts';
import Breadcrumbs from '../components/breadcrumb';
import CommonAvatar from '../components/avatar';
import { backButtonSVG } from '../utils/svg';
import { getSurveyStatisticsAPI } from '../api/apis/quicklinks';
import { Toaster } from '../components/toaster';
import SurveyPieCharts from './SurveyPieCharts.tsx';

const SurveyFormResponses = () => {
  const history = useHistory();
  const toaster = Toaster();
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH
  });
  const [isLoading, setIsLoading] = useState(true);
  const [responsesData, setResponsesData] = useState<any>(null);
  
  const activeTab = useSelector((state: any) => {
    return state.event.activeTab;
  });

  const breadcrumbDetails = {
    activeTab: { name: 'Home', path: '/home' },
    activeMenu: { name: 'Survey Form', path: '/survey-forms' },
    activeActivePage: { name: 'Survey Form Responses', path: '/survey-form-responses' }
  };

  useEffect(() => {
    getSurveyResponses();
  }, []);

  const getSurveyResponses = async () => {
    setIsLoading(true);
    try {
      const response = await getSurveyStatisticsAPI(1, 100, 'statistics');
      if (response?.error) {
        toaster(response?.message || 'Failed to load survey responses', 'error');
        return;
      }
      setResponsesData(response?.data?.data || {});
    } catch (error) {
      toaster('Failed to load survey responses', 'error');
    } finally {
      setIsLoading(false);
    }
  };

  const handleBackClick = () => {
    history.push('/survey-forms');
  };

  if (isLoading) {
    return (
      <Box
        bg={COLORS.THEME_BACKGROUND}
        pb={8}
        minHeight={'100vh'}
        justifyContent="center"
        alignItems="center"
      >
        <Spinner size="lg" color={COLORS.THEME_COLOR} />
      </Box>
    );
  }

  return (
    <Box
      bg={COLORS.THEME_BACKGROUND}
      pb={8}
      minHeight={'100vh'}
    >
      <Box bg={COLORS.WHITE_COLOR}>
        {MobileWindow ? (
          <MobileHeader
            showTabs={false}
            quicklink='yes'
          />
        ) : (
          <>
            <WebHeader
              showTabs={false}
              quicklink='yes'
            />
            <Box
              p={4}
              px={'5rem'}
            >
              <Breadcrumbs path={breadcrumbDetails} />
            </Box>
          </>
        )}
      </Box>
      
      <VStack
        pt={7}
        pr={MobileWindow ? '13px' : '4rem'}
        space={5}
        pl={MobileWindow ? '13px' : '5rem'}
      >
        <HStack
          justifyContent={'space-between'}
          alignItems={'center'}
        >
          <HStack space={3} alignItems="center">
            <CommonAvatar
              width={MobileWindow ? '35px' : '50px'}
              height={MobileWindow ? '35px' : '50px'}
              bgcolor='transparent'
              svg={backButtonSVG}
              svgwh='24'
              view='0 0 36 36'
              onPress={handleBackClick}
              touchable={true}
            />
            <Text
              fontSize={
                MobileWindow ? '22px' : COMMONFONTSIZE.HEADER_TEXT_FONT_SIZE
              }
              fontWeight={COMMONFONTWEIGHT.LARGE_FONT_WEIGHT}
            >
              Survey Form Responses
            </Text>
          </HStack>
        </HStack>

        {responsesData && (
          <SurveyPieCharts 
            data={responsesData}
            activeTab={activeTab}
            MobileWindow={MobileWindow}
          />
        )}
      </VStack>
    </Box>
  );
};

export default SurveyFormResponses; 